import { Modal } from 'antd';
import styled from 'styled-components';
import { NeutralColors } from 'theme';

const CustomModal = styled(Modal)`
  .fms-modal {
    padding: 0;
    border-radius: 8px;
  }

  .fms-modal-content {
    padding: 0;
    overflow: hidden;
    min-height: 600px;
    display: flex;
  }

  .fms-modal-body {
    padding: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    flex: 1;
  }

  .fms-modal-close {
    position: absolute;
    right: 16px;
    top: 16px;
    z-index: 10;
  }
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background-color: ${NeutralColors[0]};
  overflow: hidden;
  min-height: 400px;
`;

const ContentWrapper = styled.div`
  display: flex;
  flex: 1;
  overflow: hidden;
`;

export { Container, ContentWrapper, CustomModal as Modal };
